export function isDevMode(host: string): boolean {
  return /^(dev|localhost|192\.|172\.)/.test(host)
}

export function isProdMode(host: string): boolean {
  return !isDevMode(host)
}

export function isStagMode(host: string): boolean {
  return !isDevMode(host) && /^stg/.test(host)
}
